import { memo } from 'react';
// import { Path as _Path, Rect as _Rect, Svg as _Svg } from 'react-native-svg'
import { Path as _Path, Rect as _Rect, Svg as _Svg } from 'react-native-svg';
import { themed } from './themed';

const Icon = (props) => {
  const { color, size } = props;
  return (
    <_Svg
      width={size}
      height={size}
      viewBox="0 0 46 46"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <_Path
        d="M3.42659 19.1033H11.1513V39.6719H3.42988C3.21558 39.6723 3.00331 39.6304 2.8052 39.5487C2.6071 39.467 2.42705 39.3471 2.27537 39.1957C2.12369 39.0443 2.00335 38.8645 1.92124 38.6666C1.83914 38.4686 1.79687 38.2564 1.79688 38.0421V20.733C1.79688 20.3008 1.96858 19.8862 2.27421 19.5806C2.57984 19.275 2.99436 19.1033 3.42659 19.1033Z"
        stroke="#393939"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <_Path
        d="M11.1735 39.7671L13.5228 40.9401C14.4329 41.3936 15.4351 41.6268 16.4536 41.6236H37.8403C38.746 41.6224 39.6201 41.2906 40.2984 40.6904C40.9766 40.0902 41.4123 39.2629 41.5236 38.3641L44.1292 21.5446C44.2084 21.0213 44.1758 20.4871 44.0335 19.9773C43.8913 19.4676 43.6426 18.9937 43.3039 18.587C42.9652 18.1803 42.5442 17.85 42.0685 17.6179C41.5929 17.3858 41.0735 17.2571 40.5445 17.2403H26.2319V7.75442C26.2274 7.27143 26.1262 6.79423 25.9343 6.35097C25.7424 5.90772 25.4636 5.50738 25.1145 5.17358C24.7654 4.83978 24.353 4.57927 23.9016 4.40742C23.4502 4.23557 22.9689 4.15586 22.4862 4.17299C21.8723 4.16653 21.2671 4.31933 20.7298 4.61648C20.1926 4.91362 19.7415 5.34496 19.4206 5.86842L11.1406 19.1033V39.6718"
        stroke="#393939"
        strokeWidth="1.5"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </_Svg>
  );
};
Icon.displayName = 'HelpFullRegular';
const HelpFullRegular = memo(themed(Icon));
export { HelpFullRegular };
